import { render } from "./Search.vue?vue&type=template&id=0f4de7ca&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=0f4de7ca&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0f4de7ca"

export default script